<template>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Profile Settings</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Profile Settings</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="card">
								
								<form @submit.prevent="submit">
								<div class="card-body" style="min-height:530px"> 
									
									<!-- <div class="alert alert-danger" v-if="errors">
										{{ errors }}
									</div>
									
									<div class="alert alert-info" v-if="mesg">
										{{ mesg }}
									</div> -->
									<!-- Profile Settings Form -->
										<div class="row form-row">
											<!-- <div class="col-12 col-md-12">
												<div class="form-group">
													<div class="change-avatar">
														<div class="profile-img">
															<img src="@/assets/img/instructors/team3.jpg" alt="User Image">
														</div>
														<div class="upload-img">
															<div class="change-photo-btn">
																<span><i class="fa fa-upload"></i> Upload Photo</span>
																<input type="file" class="upload">
															</div>
															<small class="form-text text-muted">Allowed JPG, GIF or PNG. Max size of 2MB</small>
														</div>
													</div>
												</div>
											</div> -->
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Username <span class="text-danger">*</span></label>
													<input type="text" class="form-control" v-model="form.username" required>
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Email <span class="text-danger">*</span></label>
													<input type="email" class="form-control" v-model="form.email" required>
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Nama Lengkap Anda<span class="text-danger">*</span></label>
													<input type="text" class="form-control" v-model="form.namauser" required>
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Nomor Ponsel <span class="text-danger">*</span></label>
													<input type="text" class="form-control" v-model="form.no_hp"  @input="acceptNumber" required>
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Tanggal Lahir <span class="text-danger">*</span></label>
													<div class="cal-icon">
														<input type="text" class="form-control datepicker" v-model="form.birthday" required>
													</div>
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Gender</label>
													<select class="form-control select" v-model="form.gender">
														<option value="P">Perempuan</option>
														<option value="L">Laki-laki</option>
													</select>
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Alamat Rumah</label>
													<input type="text" class="form-control" v-model="form.address">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Media Sosial (IG)</label>
													<input type="text" v-model="form.medsos" class="form-control">
												</div>
											</div>
											<!-- <div class="col-12">
												<div class="form-group">
												<label>Address</label>
													<input type="text" class="form-control" value="806 Twin Willow Lane">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>City</label>
													<input type="text" class="form-control" value="Old Forge">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>State</label>
													<input type="text" class="form-control" value="Newyork">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Zip Code</label>
													<input type="text" class="form-control" value="13420">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Country</label>
													<input type="text" class="form-control" value="United States">
												</div>
											</div> -->
										</div>
										
										<div class="row form-row">
											
											
											<div class="col-md-12 col-sm-12">
											<hr>
											<div class="comp-header"><h3 class="comp-title">Ubah Password</h3> <div class="line"></div></div>
											</div>
											
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Password Baru </label>
													<input type="text" class="form-control" v-model="form.newpassword" >
												</div>
											</div>

										</div>
									<!-- /Profile Settings Form -->
									
								</div>
								<div class="card-footer text-center">
									<button type="submit" class="btn btn-primary submit-btn" >Simpan Perubahan</button>
								</div>								
								</form>
							</div>
							
							
						</div>
					</div>
				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
</template>

<script>
import Sidebar from '../Sidebar';
import axios from 'axios';

export default {
    components: {
        Sidebar
    },
	name: 'ProfileSetting',
	data() {
		return {
			form: {
				username:'',email: '',namauser:'',no_hp:'',
				birtday:'',gender:'',address:'',medsos:'', newpassword:''		
			},
			errors: null,
			mesg: null
		}
	},
	mounted() {
		axios.get('api/user/'+localStorage.getItem('idUser')).then(response => {
		this.form = response.data.data
		})
	},
	methods: {
		
		acceptNumber() {
			// console.log(this.noHp);
        	var x = this.form.no_hp.replace(/\D/g, '').match(/(\d{0,4})(\d{0,4})(\d{0,4})/);
			this.form.no_hp = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
		},

        submit(){
            axios.post('api/userupdate', this.form)
                .then(function( response ){
					if(response.data.status == "error"){
						this.errors = response.data.data;
					} else {
						swal.fire(
							'Sukses!',
							'Simpan perubahan berhasil!',
							'success'
						);
					}
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Siswa/ProfileSettings/index.vue